import { Component, EventEmitter, Input, Output } from "@angular/core";
import { RouterLink } from "@angular/router";
import { TranslateModule, TranslatePipe } from "@ngx-translate/core";

import { MatTooltip } from "@angular/material/tooltip";
import { DeviceDetectService } from "../../../services/device-detect.service";

@Component({
  selector: "app-info-icon",
  templateUrl: "./info-icon.component.html",
  styleUrls: ["./info-icon.component.css"],
  imports: [RouterLink, TranslateModule, TranslatePipe, MatTooltip],
})
export class InfoIconComponent {
  @Input() isInfoNavigation = true;
  @Input() tooltipText = "shared.learnMore";
  @Output() toggle = new EventEmitter<void>();

  isMobile: boolean;

  constructor(
    private deviceDetect: DeviceDetectService
  ) {
    this.isMobile = this.deviceDetect.isMobile;
  }

  onInfoButtonToggle() {
    if (!this.isInfoNavigation) {
      this.toggle.emit();
    }
  }
}
